import * as React from "react";
import FormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import DropDown from "../../../../hiberUiKit/src/molecules/DropDown/DropDown";
import {LabelableProps} from "../../../common/props/LabelableProps";
import {FormGroupProps} from "../../../common/props/FormGroupProps";
import {option} from "ts-option";
import {CustomFieldType} from "../../../../model/customField/CustomField";
import {DisableableProps} from "../../../common/props/DisableableProps";

type Props = FormGroupProps<string> & LabelableProps & DisableableProps

/**
 * Custom field type form group
 */
export default class FieldTypeFormGroup extends React.Component<Props> {
	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().orNull}
					   customClass={"c-dropdown-form-group"}>
				<DropDown items={Object.keys(CustomFieldType)}
						  itemToLabel={(item: any) => CustomFieldType[item]}
						  itemToId={(item: string) => item}
						  onSelect={this.onChange}
						  selectedItemId={this.props.field.getOptionalValue().orNull}
						  disabled={this.props.disabled}/>
			</FormGroup>
		)
	}

	onChange = (item: string) => {
		if (item !== this.props.field.getValue()) {
			this.props.onChange(this.props.field.updateValue(option(item)));
		}
	}
}